<template>
  <component
    class="c-availability-profile pt-4 pt-sm-2"
    :is="tag" v-bind="attrs"
  >

    <!-- 車両名 -->
    <h2 class="text-subtitle-2 mb-2">
      <small class="mr-1">{{car.maker}}</small>
      <span class="mr-1">{{car.name}}</span>
      <span v-html="vkey"></span>
    </h2>

    <div class="d-flex flex-row align-center">
      <!-- 画像 -->
      <v-img
        class="c-availability-image rounded"
        :src="car.image"
        :aspect-ratio="16/9"
      />

      <!-- サマリ情報 -->
      <div class="c-availability-summary caption ml-2">
        <div>{{car.categoryName}}</div>
        <div>{{summary}}</div>
        <div v-html="tags"></div>
        <!-- div>{{car.chargeText}}</div -->
      </div>
    </div>
  </component>
</template>

<style lang="scss">
.v-application .c-availability-profile {
  min-width: 18.5rem;
}

.v-application a.c-availability-profile {
  display: block;
  color: inherit;
  text-decoration: none;
}

.c-availability-image {
  width: 8rem;
  flex: 0 0 8rem;
  border: thin solid rgba(255, 255, 255, 0.12);
}

.AttributesIcon {
  display: inline-block;
  padding: 2px 4px;
  margin-right: 4px;
  margin-bottom: 4px;
  border-radius: 4px;
}
.Attributes_Dark {
  color: #fff;
}
.Attributes_Bright {
  color: #000;
}
</style>

<script>
export default {
  name: 'CProfile',
  props: {
    car: {
      type: Object,
      required: true
    }
  },
  computed: {
    tag () {
      return this.car.hasDetails ? 'router-link' : 'div'
    },
    attrs () {
      if (this.tag === 'div') {
        return
      }

      return {
        to: { name: 'car', params: { carid: this.car.id } }
      }
    },
    summary () {
      const summary = []

      const attrs = this.car.attributes

      if (attrs.cc > 0) {
        summary.push(`${attrs.cc}cc`)
      }
      if (attrs.fuel) {
        summary.push(attrs.fuel)
      }
      if (attrs.seats > 0) {
        summary.push(`乗車${attrs.seats}名`)
      }
      if (attrs.bed > 0) {
        summary.push(`就寝${attrs.bed}名`)
      }
      if (attrs.days) {
        summary.push(`最大利用 ${attrs.days}日`)
      }

      return summary.join(' / ')
    },
    vkey () {
      const tags = []

      const attrs = this.car.attributes

      if (attrs.vkey || attrs.keykey) {
        tags.push('24h貸出')
      }

      return this.tags_html(tags)
    },
    tags () {
      const tags = []

      const attrs = this.car.attributes

      tags.push(attrs.smoke ? '喫煙' : '禁煙')
      tags.push(attrs.mission ? 'MT' : 'AT')
      if (attrs.drive === 1) {
        tags.push('4WD')
      }

      if (attrs.etc) {
        tags.push('ETC')
      }
      if (attrs.navi) {
        tags.push('カーナビ')
      }
      if (attrs.studless) {
        tags.push('スタッドレス可')
      }
      if (attrs.tags) {
        tags.push(...attrs.tags)
      }

      return this.tags_html(tags)
    }
  },

  methods: {
    font_color_class () {
      let ClassName = ''
      if (this.isDarkColor('primary') === true) {
        ClassName = 'Attributes_Dark'
      } else {
        ClassName = 'Attributes_Bright'
      }
      // 暫定で
      ClassName = 'Attributes_Dark'
      return ClassName
    },

    tags_html (tags) {
      // 配列かどうか
      if (Array.isArray(tags)) {
      } else {
        return
      }

      // テーマ色設定
      const FontColor = this.font_color_class()
      const SpanTag = '<span class="AttributesIcon ' + FontColor + ' primary">'

      // HTMLタグに変換
      let HTML = ''
      for (let i = 0; i < tags.length; i++) {
        HTML = HTML + SpanTag + tags[i] + '</span>'
      }

      return HTML
    }
  }
}
</script>
